import React from "react";
import "./FreeText.scss";
import { FreeTextConfig } from "./FreeTextEditor";

const FreeText = ({ content, height }: FreeTextConfig) => {
  return (
    <div className="quill-rendered-content bg-white" style={{ height: `${height ?? "auto"}px`}}>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};


export default FreeText;
